var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoMobile = function SvgVideoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.111 9.002C5.393 9.002 4 10.467 4 12.274V23.73c0 1.808 1.393 3.273 3.111 3.273H21.89c1.718 0 3.111-1.465 3.111-3.273V12.274c0-1.807-1.393-3.272-3.111-3.272H7.11Zm20.031 5.8c-.404.335-.642.866-.642 1.431v3.537c0 .565.238 1.097.642 1.432l4.846 4.02c.834.692 2.012.021 2.012-1.145v-12.15c0-1.167-1.178-1.837-2.012-1.145l-4.846 4.02Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgVideoMobile;